'use client'
import { Transition } from 'react-transition-group';
import { useRef, ReactNode, useEffect } from "react"
import { IconClose } from "@/components/icon/master"
import { RemoveScroll } from "react-remove-scroll"
const _Direction = ['top', 'bottom', 'left', 'right'] as const
const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
}

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};
type TPopup = {
  children: ReactNode,
  headSlot?: ReactNode,
  show: boolean,
  onClose: () => void,
  direction?: (typeof _Direction)[number],
  clickOverlay?: boolean,
}
export function Popup(props: TPopup & React.HTMLAttributes<HTMLDivElement>) {
  const nodeRef = useRef(null);
  const { className, children, headSlot, show, onClose, direction = 'bottom', clickOverlay = true } = props;
  function disableScroll(e: any) {
    e.preventDefault();
  }
  useEffect(() => {
    if (show) {
      document.body.removeEventListener('touchmove', disableScroll)
    } else {
      document.body.removeEventListener('touchmove', disableScroll)
    }
    return () => {
      document.body.removeEventListener('touchmove', disableScroll)
    }
  }, [show])

  return (
    <Transition nodeRef={nodeRef} in={show} timeout={duration} onExited={onClose} unmountOnExit>
      {state => (
        <RemoveScroll>
          <div ref={nodeRef} className={`popup-container`} style={{
            ...defaultStyle,
            ...transitionStyles[state as keyof typeof transitionStyles]
          }} >
            <div className="popup-overlay" onClick={() => {
              if (clickOverlay) onClose()
            }}></div>
            <div className={`popup-content-wrapper popup-from-${direction} ${!show && direction ? `popup-hideto-${direction}` : ''}`}>
              <div className="popup-header-wrapper" title='Close popup'>
                <div className="popup-header-slot">
                  {headSlot}
                </div>
                <IconClose onClick={onClose} aria-label="Close popup" className="popup-close-icon" />
              </div>
              <div className={`popup-body-wrapper ${className}`}>
                {children}
              </div>
            </div>
          </div>
        </RemoveScroll>
      )}
    </Transition>
  );
}